import '../styles/pages.css';

export default function Contact() {
  return (
    <div className="page-container contact-page">
      <div className="contact-content">
        <section className="contact-info" style={{ alignItems: 'center' }}>
          <div className="info-items">
            <div className="info-item">
              <h3>📍 Location</h3>
              <p>Annapolis, Maryland</p>
            </div>
            <div className="info-item">
              <h3>📧 Email</h3>
              <p>
                <a href="mailto:agorbz@annapolismanstudios.com">
                  agorbz@annapolismanstudios.com
                </a>
              </p>
            </div>
            <div className="info-item">
                <h3>Instagram</h3>
                <a href="https://www.instagram.com/annapolis.man.studios/" target="_blank" rel="noopener noreferrer">
                  @annapolis.man.studios
                </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
